// Downloads fill only this much: the app still has to parse and execute what landed, and a bar
// sitting at 100% through that reads as a hang.
const DOWNLOAD_SHARE = 0.9;
// The bar never claims completion — the loader leaves when React replaces the markup.
export const PROGRESS_CEILING = 0.95;
// Per second, not per frame: 1 - exp(-rate * dt) is the frame-rate independent form of a lerp,
// so the bar moves at one speed on 60Hz and 120Hz alike.
const APPROACH_PER_SECOND = 7.5;
const CREEP_PER_SECOND = 0.07;
// A backgrounded tab resumes with a multi-second gap, which would jump the bar.
const MAX_STEP_SECONDS = 0.1;

export type ProgressStep = {
    shown: number;
    landed: number;
    /** 0 when the request set is not trackable — the bar then advances on creep alone. */
    expected: number;
    deltaSeconds: number;
};

export function nextProgress({ shown, landed, expected, deltaSeconds }: ProgressStep): number {
    const step = Math.min(Math.max(deltaSeconds, 0), MAX_STEP_SECONDS);
    const target = expected > 0 ? Math.min(1, landed / expected) * DOWNLOAD_SHARE : 0;
    const creep = CREEP_PER_SECOND * step;

    // Nothing on screen yet: open at the target rather than ease up to it. On a warm cache that
    // target is already the full download share, and easing would animate a finished load.
    if (shown === 0) {
        return Math.min(PROGRESS_CEILING, target + creep);
    }

    const approach = Math.max(0, target - shown) * (1 - Math.exp(-APPROACH_PER_SECOND * step));
    return Math.min(PROGRESS_CEILING, shown + approach + creep);
}
